const messages = {
  box: {
    title: "Online Sichtbarkeit",
  },
  title: "Online Sichtbarkeit",
  description:
    "Steigern und steuern Sie Ihre digitale Sichtbarkeit auf POS-Level mit UBERALL",
  category_title: "uberall - verbesserung der digitalen sichtbarkeit",
  category_description:
    "Nutzen Sie jetzt Ihre Prämienpunkte, um ihr Digitales Standortmarketing auf die nächste Stufe zu heben. Mithilfe der Plattform uberall unterstützt Bridgestone Handelspartner bei der Optimierung der Online-Präsenz, um mehr Besucher zu generieren. Und das auf über 100 Plattformen wie Google, Facebook, Bing oder Trustpilot.",
  content: "Nutzen Sie jetzt die Vorteile von uberall:",
  point1: "Optimierung der Online-Sichtbarkeit",
  point2: "Bequeme Steuerung & Kontrolle von POS-Standorten",
  point3: "Lokale Sichtbarkeit, Bewertungen und Social Media Content verfolgen",
  footer:
    "Um detaillierte Informationen zu erhalten und einen ersten Eindruck von uberall zu gewinnen, schauen Sie sich das folgende Video an.",
  period: "Laufzeit: 1 Jahr",
  form: {
    title: "So nutzen Sie uberall für Ihr Unternehmen:",
    point1: "Für 480 Punkte ein Jahres-Abo abschliessen",
    point2: "Nach interner Prüfung erhalten Sie eine Bestätigung",
    point3: "keine automatische Verlängerung",
    pointDiscount: "Punkte in einem {price} EUR von für folgende",
    howMuch: "Wie viele Punkte möchten sie einsetzen?",
  },
  uberall: {
    title: "UBERALL ABONNEMENT",
  },
  haveQuestion: "Sie haben eine Frage?",
  contactUs: "Dann senden Sie uns gerne eine Mail an",
};

export default {
  messages,
};
